import {forkJoin, of} from 'rxjs';
// Angular
import {Injectable} from '@angular/core';
// RxJS
import {map, mergeMap, tap} from 'rxjs/operators';
// NGRX
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
// CRUD
import {QueryParamsModel, QueryResultsModel} from '../../_base/crud';
// Services
// State
import {AppState} from '../../../core/reducers';
// Actions
import {
	ManyProductGroupsDeleted,
	OneProductGroupDeleted,
	ProductGroupActionTypes,
	ProductGroupCreated,
	ProductGroupOnServerCreated,
	ProductGroupsPageLoaded,
	ProductGroupsPageRequested,
	ProductGroupsPageToggleLoading,
	ProductGroupsStatusUpdated,
	ProductGroupUpdated
} from '../_actions/product-group.actions';
import {ProductGroupsService} from '../_services/product-groups.service';

@Injectable()
export class ProductGroupEffects {
	showPageLoadingDistpatcher = new ProductGroupsPageToggleLoading({isLoading: true});
	showLoadingDistpatcher = new ProductGroupsPageToggleLoading({isLoading: true});
	hideActionLoadingDistpatcher = new ProductGroupsPageToggleLoading({isLoading: false});

	@Effect()
	loadProductGroupsPage$ = this.actions$
		.pipe(
			ofType<ProductGroupsPageRequested>(ProductGroupActionTypes.ProductGroupsPageRequested),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showPageLoadingDistpatcher);
				const requestToServer = this.productGroupsService.findProductGroups(payload.page);
				const lastQuery = of(payload.page);
				return forkJoin(requestToServer, lastQuery);
			}),
			map(response => {
				const result: QueryResultsModel = response[0];
				const lastQuery: QueryParamsModel = response[1];
				return new ProductGroupsPageLoaded({
					productGroups: result.items,
					totalCount: result.totalCount,
					page: lastQuery
				});
			}),
		);

	@Effect()
	deleteProductGroup$ = this.actions$
		.pipe(
			ofType<OneProductGroupDeleted>(ProductGroupActionTypes.OneProductGroupDeleted),
			mergeMap(({payload}) => {
					this.store.dispatch(this.showLoadingDistpatcher);
					return this.productGroupsService.deleteProductGroup(payload.id);
				}
			),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			}),
		);

	@Effect()
	deleteProductGroups$ = this.actions$
		.pipe(
			ofType<ManyProductGroupsDeleted>(ProductGroupActionTypes.ManyProductGroupsDeleted),
			mergeMap(({payload}) => {
					this.store.dispatch(this.showLoadingDistpatcher);
					return this.productGroupsService.deleteProductGroups(payload.ids);
				}
			),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			}),
		);

	@Effect()
	updateProductGroupsStatus$ = this.actions$
		.pipe(
			ofType<ProductGroupsStatusUpdated>(ProductGroupActionTypes.ProductGroupsStatusUpdated),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showLoadingDistpatcher);
				return this.productGroupsService.updateStatusForProductGroup(payload.productGroups, payload.status);
			}),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			}),
		);

	@Effect()
	updateProductGroup$ = this.actions$
		.pipe(
			ofType<ProductGroupUpdated>(ProductGroupActionTypes.ProductGroupUpdated),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showLoadingDistpatcher);
				return this.productGroupsService.updateProductGroup(payload.productGroup);
			}),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			}),
		);

	@Effect()
	createProductGroup$ = this.actions$
		.pipe(
			ofType<ProductGroupOnServerCreated>(ProductGroupActionTypes.ProductGroupOnServerCreated),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showLoadingDistpatcher);
				return this.productGroupsService.createProductGroup(payload.productGroup).pipe(
					tap(res => {
						this.store.dispatch(new ProductGroupCreated({productGroup: res}));
					})
				);
			}),
			map(() => {
				return this.hideActionLoadingDistpatcher;
			}),
		);

	// @Effect()
	// init$: Observable<Action> = defer(() => {
	//     const queryParams = new QueryParamsModel({});
	//     return of(new ProductGroupsPageRequested({ page: queryParams }));
	// });

	constructor(private actions$: Actions, private productGroupsService: ProductGroupsService, private store: Store<AppState>) {
	}
}
